<template>
  <router-link
    :to="routers.settingTeamMembers"
    class="tw-flex tw-w-full tw-items-center tw-justify-between tw-cursor-pointer !tw-no-underline"
    @click.stop="onSelect"
  >
    <div
      class="tw-flex tw-min-h-[50px] tw-justify-center tw-items-center tw-gap-[15px]"
    >
      <GlobalAvatar
        v-if="!data?.avatar?.avatarImageFileId"
        :name="data?.fullName || data?.email"
      />
      <div class="tw-flex tw-flex-col">
        <span class="member-topic-title">
          {{ `${data?.firstName} ${data?.lastName}` }}
        </span>
        <span class="member-topic-sub-description">{{
          data?.org.orgNameShort
        }}</span>
      </div>
      <div class="member-topic-role tw-ml-[10px]">
        <span>
          {{ data?.roles?.[0].roleName }}
        </span>
      </div>
    </div>
    <IconRight />
  </router-link>
</template>

<script setup lang="ts">
import { routers } from "@/utils/constants";
import EventEmitter from "@/utils/eventEmitter";

/** components */
import IconRight from "@/components/common/globalSearch/menuSearch/iconChevronRight.vue";
import GlobalAvatar from "@/components/common/globalAvatar.vue";

const props = defineProps<{
  data: any;
}>();

const emit = defineEmits<{
  (e: "close-menu"): void;
}>();

const onSelect = () => {
  emit("close-menu");
  setTimeout(() => {
    EventEmitter.emit("member-management-open-profile-modal", props.data);
  }, 500);
};
</script>

<style scoped>
.member-topic-title {
  font-family: Poppins, sans-serif;
  font-size: 13px;
  font-weight: 500;
  color: #387dff;
  user-select: none;
}
.member-topic-sub-description {
  font-family: Poppins, sans-serif;
  font-size: 11px;
  font-weight: 400;
  color: #878787;
  user-select: none;
}
.member-topic-role {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 20px;
  border-radius: 4px;
  padding: 3px 5px;
  background-color: rgba(239, 240, 241, 0.5);
  & > span {
    font-family: Poppins, sans-serif;
    font-size: 11px;
    font-weight: 500;
    color: #231f20;
  }
}
</style>
